// PublishedCoursesList.jsx
import {
  List,
  Datagrid,
  TextField,
  ImageField, 
  useNotify,
  useRefresh,
  useDataProvider,
  useRecordContext,
  useRedirect,
} from "react-admin";
import {  Button,Dialog, DialogActions,DialogContent,DialogTitle} from "@mui/material";
import { useState } from "react";

const UnpublishButton = ({onUnpublish}) => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  //const refresh = useRefresh();
  const redirect = useRedirect();

  const [openConfirm, setOpenConfirm] = useState(false);

  
  const handleUnpublish = async () => {
    try {
      await dataProvider.update("courses", {
        id: record.id,
        data: { isPublished: false },
      });
      notify("Curso despublicado correctamente", { type: "info" });
      setOpenConfirm(false);
      onUnpublish();// fuerza recarga
      redirect("list","courses"); // Redirige para recargar la lista filtrada
    } catch (error) {
      notify("Error al despublicar el curso", { type: "error" });
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        onClick={(e) => {
          e.stopPropagation(); // Previene navegación
          setOpenConfirm(true);
        }}
      >
        Despublicar
      </Button>

      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>¿Estás seguro?</DialogTitle>
        <DialogContent>
          ¿Querés despublicar el curso "{record.title}"?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>Cancelar</Button>
          <Button onClick={handleUnpublish} variant="contained" color="secondary">
            Sí, despublicar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

// Lista de cursos publicados
const PublishedCoursesList = () => {
  const refresh = useRefresh();

 
   return (
    <List      
      title="Cursos Publicados"
      resource="courses"
      filter={{ isPublished: true }}
    >
      <Datagrid rowClick="edit">
        <TextField source="title" />
        <TextField source="level" />
        <ImageField source="image" title="title" />
        <UnpublishButton onUnpublish={refresh} />
      </Datagrid>
    </List>
  );
};

export default PublishedCoursesList;